module.exports = __webpack_public_path__ + "static/img/gb-700-377bb.7b17780.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2026/gb-700-377bb.jpg
// module id = WuwX
// module chunks = 0